import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ConceptList } from '@/components/knowledge/ConceptList';
import { ConceptDetail } from '@/components/knowledge/ConceptDetail';
import { useConceptsStore } from '@/stores/concepts';

export function RawConceptsPage() {
  const { conceptId } = useParams<{ conceptId?: string }>();
  const { fetchConceptDetail, selectConcept } = useConceptsStore();

  useEffect(() => {
    if (conceptId) {
      fetchConceptDetail(conceptId);
    } else {
      selectConcept(null);
    }
  }, [conceptId, fetchConceptDetail, selectConcept]);

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
        <div>
          <h1 className="text-xl font-semibold text-navy-900">Raw Concepts</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Pre-resolution KnowledgeConcept documents from Firestore
          </p>
        </div>
      </div>

      <div className="flex flex-1 min-h-0">
        <div className="w-80 flex-shrink-0">
          <ConceptList />
        </div>
        <div className="flex-1 min-w-0 bg-white">
          <ConceptDetail />
        </div>
      </div>
    </div>
  );
}
